import { ConfigProvider, DatePicker } from "antd";
import React from "react";

const { RangePicker } = DatePicker;

const RangeDatePicker = ({
  value,
  picker,
  onChange,
  defaultValue,
  format,
  placeholder,
  showToday = false,
  showTime = false,
  showNow = false,
  allowClear = true,
  size,
  className,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          DatePicker: {
            cellHoverWithRangeBg:'orange',
            hoverBorderColor:'none',
            /* here is your component tokens */
          },
        },
      }}
    >
      <RangePicker
        onChange={onChange}
        className={className}
        picker={picker}
        defaultValue={defaultValue}
        format={format}
        value={value}
        placeholder={placeholder}
        showToday={showToday}
        showTime={showTime}
        showNow={showNow}
        allowClear={allowClear}
        size={size}
        {...props}
      />
    </ConfigProvider>
  );
};

export default RangeDatePicker;
